import React, { ReactNode } from 'react';

interface BadgeProps {
    children: ReactNode;
    color?: 'violet' | 'green' | 'yellow' | 'blue' | 'red';
    className?: string;
}

export const Badge = ({ children, color = 'violet', className = '' }: BadgeProps) => {
    const colors = {
        violet: 'bg-violet-100/50 text-violet-700 border-violet-100',
        green: 'bg-green-100/50 text-green-700 border-green-100',
        yellow: 'bg-yellow-100/50 text-yellow-700 border-yellow-100',
        blue: 'bg-blue-100/50 text-blue-700 border-blue-100',
        red: 'bg-red-100/50 text-red-700 border-red-100',
    };

    return (
        <span className={`
            px-2.5 py-1 rounded-lg text-[10px] font-bold uppercase tracking-wider border
            ${colors[color]}
            ${className}
        `}>
            {children}
        </span>
    );
};
